export { Megaphone as default } from './Megaphone';
